<template>
  <div>
    <div tabindex="-1" ref="pageTopRef"></div>
    <Header />
    <Dashboard v-if="showDashboard" @popupClose="onPopupClose" />
    <PageContents v-else />
    <Footer />
  </div>
</template>
<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import PageContents from "./PageContents.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import { ref, watch, nextTick } from "vue";
import { useRoute } from "vue-router";

export default {
  components: {
    Header,
    Footer,
    PageContents,
    Dashboard,
  },
  setup() {
    const route = useRoute();
    //data정의
    //대시보드 화면 여부
    const showDashboard = ref(false);
    const pageTopRef = ref(null);

    // 최초 진입 시 체크
    showDashboard.value = route.path === "/dashboard";

    const onPopupClose = () => {
      nextTick(() => {
        pageTopRef.value?.focus(); // 최상단으로 포커스 이동
      });
    };

    // 경로 변경 감시
    watch(
      () => route.path,
      (newPath) => {
        showDashboard.value = newPath === "/dashboard";
      }
    );
    // html에서 사용될 데이터 정의
    return {
      showDashboard,
      pageTopRef,
      onPopupClose,
    };
  },
};
</script>
